<template>
  <div>
    <div class="section__item">
      <div class="grid grid_v-margins">
        <template v-for="(event, i) in events">
          <div
            class="grid__col"
            :key="event.c"
          >
            <event-card
              :eventInfo="event"
              :results="results"
              :registrations="registrations[event.c]"
            ></event-card>
          </div>
          <div
            class="grid__col"
            :key="'banner-' + i"
            v-if="theme === 'rr' && banner && (i - 1) % 12 === 0"
          >
            <banner
              :content="banner"
              :contentMobile="bannerMobile"
            />
          </div>
        </template>
      </div>
      <div
        class="loader"
        v-show="loading"
      ></div>
      <div v-show="!loading && (!pagination.totalItems || !events.length)">
        <slot name="noResults">
          <section
            class="empty-state"
          >
            <div class="section__group mt-0">
              <div class="section__item">{{ $t('events.noResults') }}</div>
            </div>
          </section>
        </slot>
      </div>
    </div>
    <div
      v-if="pagination.totalItems > pagination.itemsPerPage"
      v-show="!loading"
    >
      <div
        class="section__item"
        v-show="pagination.page + 1 < totalPages"
      >
        <Button
          variant="secondary"
          size="lg"
          wide
          :text="$t('events.showMore')"
          @click="showMore"
        ></Button>
      </div>
      <div
        class="section__item"
      >
        <pagination
          :page="pagination.page"
          :totalItems="pagination.totalItems"
          :itemsPerPage="pagination.itemsPerPage"
          @change="changePage"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EventCard from '@/components/EventCard.vue';
import Pagination from '@/components/Pagination.vue';
import Banner from '@/components/Banner.vue';
import eventsService from '@/services/eventsService';
import { groupBy } from 'lodash';

export default {
  name: 'EventsList',
  components: {
    EventCard,
    Pagination,
    Banner,
  },
  props: {
    eventsType: String,
    results: Boolean,
    banner: String,
    bannerMobile: String,
  },
  data() {
    return {
      events: [],
      registrations: {},
      loading: true,
      pagination: {
        page: 0,
        itemsPerPage: 12,
        totalItems: 0,
      },
      filters: {},
      filtersQuery: {},
      updId: null,
    };
  },
  computed: {
    ...mapGetters('settings', ['theme']),
    totalPages() {
      return Math.ceil(this.pagination.totalItems / this.pagination.itemsPerPage);
    },
  },
  methods: {
    onFiltersChange(data, id) {
      this.updId = id;
      this.created = true;
      this.events = [];
      if (!data.parse) {
        this.pagination.page = 0;
        this.onParamsChange();
      } else {
        this.getEvents();
      }
    },
    showMore() {
      this.pagination.page += 1;
      this.onParamsChange();
    },
    changePage(page) {
      this.pagination.page = page;
      this.events = [];
      this.onParamsChange();
      window.scrollTo(0, 0);
    },
    getRequestParams() {
      const pagination = {
        Skip: this.pagination.page * this.pagination.itemsPerPage,
        Take: this.pagination.itemsPerPage,
      };
      const filters = this.$parent.getFiltersRequestParams();
      return {
        EventsLoaderType: this.eventsType ? +this.eventsType : null,
        UseTenantBeneficiaryCode: this.theme !== 'rr',
        BeneficiaryId: this.$route.query.beneficiaryId || null,
        ...pagination,
        ...filters,
      };
    },
    onParamsChange() {
      this.$emit('updateQuery');
      this.getEvents();
    },
    getEvents() {
      this.loading = true;
      setTimeout(() => {
        const data = this.getRequestParams();
        eventsService.getEventsList(data)
          .then((res) => {
            this.events.push(...res.data.Items);
            this.pagination.totalItems = res.data.TotalCount;
            this.$emit('updateTotalCount', this.pagination.totalItems);
            this.loading = false;
          });
      });
    },
    toggle(show, id) {
      if (!show) {
        return;
      }
      if (this.created && this.updId !== id) {
        this.updId = id;
        this.events = [];
        this.pagination.page = 0;
        window.scrollTo(0, 0);
        this.getEvents();
      }
    },
  },
  mounted() {
    const userId = window.userInfo ? window.userInfo.Id : null;
    if (userId) {
      eventsService.getRegistrations(userId)
        .then((res) => {
          this.registrations = res.data ? groupBy(res.data, 'EventCode') : {};
        });
    }
  },
};
</script>
